export default "__VITE_ASSET__CBw7V6Co__"